<template>
  <authenticated-layout>
    <div class="row">
      <div class="col-12">
        <fila-folhetos-table />
      </div>
    </div>
  </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/components/AuthenticatedLayout.vue";
import FilaFolhetosTable from "./components/FilaFolhetosTable.vue";

export default {
  name: "FilaFolhetos",
  components: {
    AuthenticatedLayout,
    FilaFolhetosTable,
  },
};
</script>
